module.exports = __webpack_public_path__ + "media/images/favicon-3af66762b238330460687be9c94eaead.png";